module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1a"
  }, [_vm._v("IN CROSSING")]), _vm._v(" "), _c('p', {
    staticClass: "h1b"
  }, [_vm._v("Commemorative Poem by Katy Whittingham")]), _vm._v(" "), _c('p', {
    staticClass: "h1c"
  }, [_vm._v("1814–2014")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("As far from time—as History")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("As near yourself—as Today")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("—Emily Dickinson")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Over the highest spar, can you picture a community?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sketch and shade with predetermined destiny")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and neatly settled susceptibility?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In its age of arranged marriage between land and water,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("orphaned islands, crooked rivers,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("high harvests: cotton, rods, nails, bread,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("can you still hear the tall sea tale")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as it once washed over the weary waterman")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in decidedly neutral beds?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Stop, and listen to the expectant hum")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("before orders, before eighteen guns, before")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("a simple sound could sunder, and not so simple men")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("might propose a peaceful end—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are not always words that can capture, but when")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("they do they can be too powerfully accurate,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as brazen and blazing as that infamous red glare,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("urgent as surge winds and heavily burdened like iron rails—")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("what choice did twelve Fearing men have")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("but to stand for all of the others, among them,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Cape cousins: Fancy, Nancy, and Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yet, chance is chance, and fortitude")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("matches with what sea souls might expect.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As an elephant will run from a bee,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("the mightier many set off on their watercourse")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("with deserted vow to come back.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("But with waters crossed, history did change,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("once marched streets now call out names,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("and the earlier picture—a little tired in form,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("yet finely grained with preserved intent,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("may be mounted in the celebratory frame,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("in honor of the value secured,")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("positioned at the arch of our inviting gateway.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('i', [_vm._v("Wareham resident K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATY")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HITTINGHAM")]), _vm._v(" is a poet and educator. Her book of poems")]), _vm._v(", By a Different Ocean, "), _c('i', [_vm._v("was published by Plan B Press in Virginia in 2009. She teaches English at the University of Massachusetts–Dartmouth and Bridgewater State University")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28dfe8d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crossing.vue
// module id = 72
// module chunks = 0